export default __webpack_public_path__ + "static/11-abe5142e01f050ab05459025fdc11a8c.webp";